import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

export const SortedListNoResult = ({ message, searchQuery, title }) => {
  return (
    <div className="sorted-list__nothing">
      <span className="sorted-list__nothing-title">{searchQuery ? i18n.t("table.noSearchResultsTitle") : title || i18n.t("table.nothing")}</span>
      <span className="sorted-list__nothing-result">
        {searchQuery ? i18n.t("table.noSearchResultsMessage") : message || i18n.t("table.noResult")}
      </span>
    </div>
  );
};

SortedListNoResult.propTypes = {
  message: PropTypes.string,
  searchQuery: PropTypes.string,
  title: PropTypes.string
};

SortedListNoResult.defaultProps = {
  message: "",
  searchQuery: "",
  title: ""
};



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/SortedListNoResult.js